import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Heading from "../Heading/Heading";
import { LoginButton } from "../Common Modules/Common Modules"; // Corrected import path
import "./Forgot Password.css"; // Corrected import path
import { Card, Form, Modal, Button, Spinner } from "react-bootstrap"; // Combined import for better readability
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { forgotPasswordAPI } from "../../api";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import CaptchaComponent from "../Captcha Component/Captcha Component"; // Corrected import path
import Loader from "../Loader/Loader";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const handleCaptchaVerification = (isVerified) => {
    setIsCaptchaVerified(isVerified);
  };

  const [showConfirmationSuccessModal, setShowConfirmationSuccessModal] =
    useState(false);
  const [accountCreatedSuccessfully, setAccountCreatedSuccessfully] =
    useState(false);

  const handleConfirmationAccountCreatedNo = () => {
    setShowConfirmationSuccessModal(false);
  };

  const handleConfirmationAccountCreatedYes = () => {
    setShowConfirmationSuccessModal(false);
    navigate("/");
    setAccountCreatedSuccessfully(false);
    toast.success(
      "Link sent to your email for updating password, kindly check your nominated email."
    );
  };

  const handleSuccessful = () => {
    console.log("handleSuccessful");
    setAccountCreatedSuccessfully(true);
    setShowConfirmationSuccessModal(true);
  };

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const navigate = useNavigate();

  // const navigation_path = `/user/reset_password?email=${email}`;
  const navigation_path = `/user/reset_password`;


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !validateEmail(email)) {
      setEmailError(true);
      toast.error("Please enter a valid email address.");
      // document.getElementById("email").focus();
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("email", email);
      formData.append("navigation_path", navigation_path);

      const response = await forgotPasswordAPI(formData);

      setLoading(false);

      const responseData = response.data?.response;

      if (responseData.response === true) {
        handleSuccessful();
      } else {
        setLoading(false);

        if (responseData.error_msg) {
          toast.error(responseData.error_msg);
        } else {
          toast.error(
            "An error occurred during password reset. Please try again."
          );
        }
      }
    } catch (error) {
      setLoading(false);

      console.error("Update password failed:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        setLoading(false);

        toast.error(
          "An error occurred during password reset. Please try again."
        );
      }
    }
  };

  const handleEmailChange = (event) => {
    const emailInput = event.target.value;
    setEmail(emailInput);
    setEmailError(!validateEmail(emailInput));
  };

  const validateEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      <Heading text="Welcome to the Skills Assessment Online Portal" />

      {loading && <Loader />}


      <div className="login-page-wrapper container-fluid pb-6">
        <div className="login-flex-container">
          {/* Left Side Images */}
          <div className="image-section">
            <div className="image_parent_container">
              <div className="image_container image_shift">
                <img
                  src="http://api.aqato.com.au/public/app_files/login/industry.jpg"
                  alt="decoration"
                  className="image_box"
                />
                <img
                  src="http://api.aqato.com.au/public/app_files/login/fd088efe776a4b972f02013429be4f1464a03b60.jpg"
                  alt="decoration"
                  className="image_box"
                />
              </div>

              <div className="image_container top_shift">
                <img
                  src="http://api.aqato.com.au/public/app_files/login/f5ff72b2969cfbe9c041eeee76e9005fe8cc0fbe.jpg"
                  alt="decoration"
                  className="image_box"
                />
                <img
                  src="http://api.aqato.com.au/public/app_files/login/ecc5d97c13ac710b77addcb3871bdd2270a006cf.jpg"
                  alt="decoration"
                  className="image_box"
                />
              </div>

              <div className="image_container image_shift">
                <img
                  src="http://api.aqato.com.au/public/app_files/login/474831b5be9e7b004868342d4b1fa2967b7ee391.jpg"
                  alt="decoration"
                  className="image_box"
                />
                <img
                  src="http://api.aqato.com.au/public/app_files/login/fd088efe776a4b972f02013429be4f1464a03b602322.jpg"
                  alt="decoration"
                  className="image_box"
                />
              </div>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="form-section">
            <div className="form_container">
              <div className="inner_form_container">
                <Form onSubmit={handleSubmit}>
                  {/* <Form.Group
                    controlId="formBasicEmail"
                    className="forgot-card-input"
                  >
                    <div className="input-group" style={{ height: "40px" }}>
                      <span
                        className="input-group-text"
                        style={{ backgroundColor: "#e9ecef", height: "100%" }}
                        id="emailInputGroup"
                      >
                        <i
                          className="bi bi-envelope-fill"
                          style={{
                            fontSize: "1.5rem",
                            color: "black",
                            fontWeight: "bold",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        ></i>
                      </span>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={handleEmailChange}
                        style={{ height: "100%" }}
                        id="email"
                        aria-describedby="emailInputGroup"
                      />
                    </div>

                    {emailError && (
                      <div className="error-message">
                        Invalid Email Address. Please enter a valid email. *{" "}
                      </div>
                    )}
                  </Form.Group> */}

                  <CaptchaComponent
                onCaptchaVerification={handleCaptchaVerification}
                handleSubmit={handleSubmit}
                email = {email}
                setEmail={setEmail}
              />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>



      {accountCreatedSuccessfully && (
            <Modal show={showConfirmationSuccessModal} centered>
              <Modal.Header>
                <Modal.Title
                  className="text-center w-100"
                  style={{
                    fontSize: "18px",
                    fontFamily: "Arial, sans-serif",
                    color: "#055837",
                  }}
                >
                  Update password Link Sent Successfully !
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="text-left"
                style={{ fontSize: "16px", fontFamily: "Arial, sans-serif" }}
              >
                <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                  <li style={{ marginBottom: "10px" }}>
                    <span style={{ color: "black" }}>•</span> An email has been
                    sent to your nominated email address (
                    <strong>{email}</strong>) with your account activation link.
                    Please check your email inbox for instructions on how to
                    reset your password. If you don't see the email within a few
                    minutes, please also check your spam or junk folder. If you
                    need further assistance, please contact our support team at{" "}
                    <a href="mailto:skills@aqato.com.au">skills@aqato.com.au</a>{" "}
                    for assistance.
                  </li>
                </ul>
              </Modal.Body>

              <Modal.Footer className="d-flex justify-content-center">
                <Button
                  variant="light"
                  onClick={handleConfirmationAccountCreatedYes}
                  className="w-50"
                  style={{
                    maxWidth: "130px",
                    backgroundColor: "#055837",
                    color: "#ffcc01",
                    transition: "transform 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                >
                  Okay
                </Button>
              </Modal.Footer>
            </Modal>
          )}

    </>
  );
};

export default ForgotPassword;